import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { FilterSection } from '../FilterSection'
import { defineMessages, useIntl } from 'react-intl'
import { selectFilter } from '../../../../store/selectors/filters'
import { FilterCheckBox } from '../FilterCheckBox'

// todo share these with HomeType.module.scss
import styles from './ListingStatus.module.scss'
import { useListingStatusDisplayObj } from '../../../../hooks/useListingStatusDisplayObj'
import { ListingStatusEnum } from '../../../../types/listingStatus'
import { RootState } from '../../../../store'
import { FilterProperties } from '../../../../types/filtersTypes'

export const MSG = defineMessages({
  heading: {
    id: 'HomeSearch.listings.filters.listingStatus.heading',
    defaultMessage: 'Listing status',
  },
})

export const ListingStatus = () => {
  const intl = useIntl()
  const filters = useSelector<RootState, FilterProperties>(selectFilter)

  const [selectedStatusActive, setSelectedStatusActive] = useState(false)
  const [selectedStatusPending, setSelectedStatusPending] = useState(false)

  useEffect(() => {
    setSelectedStatusActive(filters.statuses.includes(ListingStatusEnum.ACTIVE))
    setSelectedStatusPending(
      filters.statuses.includes(ListingStatusEnum.PENDING)
    )
  }, [filters])

  return (
    <FilterSection title={intl.formatMessage(MSG.heading)}>
      <fieldset className={styles.checkBoxFields}>
        <FilterCheckBox
          name={ListingStatusEnum.ACTIVE}
          isChecked={selectedStatusActive}
          label={useListingStatusDisplayObj(ListingStatusEnum.ACTIVE).text}
          onChange={() => setSelectedStatusActive(!selectedStatusActive)}
        />
        <FilterCheckBox
          name={ListingStatusEnum.PENDING}
          isChecked={selectedStatusPending}
          label={useListingStatusDisplayObj(ListingStatusEnum.PENDING).text}
          onChange={() => setSelectedStatusPending(!selectedStatusPending)}
        />
      </fieldset>
    </FilterSection>
  )
}
